// istanbul ignore next
export function redirectToLocation(url: string): void {
  if (process.env.NODE_ENV === 'development') {
    const confirmation = confirm(`Redirect to ${url}?`);

    if (!confirmation) {
      return;
    }
  }

  window.location.href = url;
}
